import React from 'react';
import '../styles/App.css';
import Sidebar from '../components/sidemenu/sidebar';
import CrudTable from '../components/cruds/crud_ROLES';

const admRoles = () => {
  return (
    <div>
        <Sidebar/>
        <div>
            <h3 className="title"> Administración Roles</h3>
        </div>
        <CrudTable/>
    </div>
  );


};

export default admRoles;